import { completeUserOnboarding } from '@/src/dal/user-dal'
import { useResolvedAuthState } from '@/src/hooks/useResolvedAuthState'
import { queryKeys } from '@/src/queries/query-keys'
import { userEntitlementSyncQueryOptions } from '@/src/queries/user-queries'
import { useMutation, useQueryClient } from '@tanstack/react-query'

/**
 * Orchestrates the full post-payment onboarding completion flow:
 * backend completion call and profile invalidation.
 */
export function useCompletePostPaymentOnboarding() {
  const queryClient = useQueryClient()
  const { authUserId } = useResolvedAuthState()

  return useMutation<void, Error, void>({
    mutationKey: queryKeys.mutations.completePostPaymentOnboarding,
    mutationFn: completeUserOnboarding,
    onSuccess: async () => {
      if (authUserId == null) {
        return
      }

      const syncedUser = await queryClient.fetchQuery(
        userEntitlementSyncQueryOptions(authUserId),
      )

      queryClient.setQueryData(queryKeys.user.profile(authUserId), syncedUser)
      await queryClient.invalidateQueries({
        queryKey: ['exercise', 'dashboard-info'],
      })
    },
  })
}
